import ftl2js from './ftl2js.js';
import js2ftl from './js2ftl.js';
export { ftl2js, js2ftl };
export default {
  ftl2js: ftl2js,
  js2ftl: js2ftl
};